<template>
  <b-row  class="align-items-center">
    <b-col cols="auto">
      <b-btn variant="text" class="text-white" style="">
        <small>Project: </small>
        <small class="font-weight-bold">{{ project && project.name }}</small>
      </b-btn>
    </b-col>
    <b-col cols="auto" class="col-overlay">
      <small class="text-capitalize">
        <b>Mode:</b> {{ mode }} <span v-if="equipment">{{ equipment.shape_type }}</span>
      </small>
    </b-col>
    <b-col cols="auto"  class="col-overlay" v-if="equipment">
      <small class="text-capitalize" >
        <b>Equip.:</b> {{ $t(`equipment_type.${equipment.name}`) }}
      </small>
    </b-col>
    <b-col cols="auto" v-if="isPDFProject && false">
        <small>
          {{ $t("menu.placeholder.unit_scale") }}:
          <font-awesome-icon v-if="isScaleSet" icon="check-circle" class="text-success" />
          <font-awesome-icon v-else icon="warning" class="text-danger" />
        </small>
    </b-col>
    <b-col />
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: "ProjectHeader",
    data(){
      return {
        equip: null,
      }
    },
    computed: {
      ...mapGetters({
        'mode' : 'sections/currentMode',
        'shape' : 'sections/currentShape',
        'unitScale': 'projects/scale',
        'isScaleSet': 'projects/isScaleSet',
        'scale' : 'assets/scale',
        'equipment' : 'sections/currentEquipmentConfig',
        'project': 'projects/item'
      }),
      isPDFProject(){
        return this.$route.name == 'project-pdf'
      }
    },
    methods:{
      selectEquipment(item, index){
        this.equip = index.replaceAll("_"," ")
      }
    }
}
</script>